module.exports = __webpack_public_path__ + "static/media/pt_BR.5091e787.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/flags/rect/pt_BR.svg
 ** module id = 1254
 ** module chunks = 0
 **/